'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useCurrentDrawInfo } from '../hooks/useCurrentDrawInfo.js';
import { SubscribedDrawContainer } from './SubscribedDrawContainer.js';
/**
 * Subscribes to current draw updates.
 *
 * @returns Subscription container if current draw
 */
export function SubscribedCurrentDrawContainer() {
    const currentDraw = useCurrentDrawInfo();
    if (!currentDraw.drawNumber) {
        return undefined;
    }
    return (_jsx(SubscribedDrawContainer, { drawNumber: currentDraw.drawNumber, product: currentDraw.product.type, subscriptionType: "DRAW" }));
}
//# sourceMappingURL=SubscribedCurrentDrawContainer.js.map